import React, { Component } from 'react';
import { Provider } from 'react-alert';
import AlertTemplate from 'react-alert-template-basic';
import Routes from './Routes.jsx';

const alertOptions = {
  position: 'top center',
  timeout: 4000,
  transition: 'fade',
  offset: '150px',
  zIndex: 9999
}

export default class App extends Component {

  render() {
    return (
      <Provider template={AlertTemplate} {...alertOptions}>
        <Routes />
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App.jsx